import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import CheckmarkIcn from 'views/ui/icons/checkmark-icon';
import { Theme } from 'ui_system/theme';
import { t } from 'services/translation';

const CheckmarkIcon = styled(CheckmarkIcn)`
  height: 7px;
  min-width: 10px;
  fill: ${Theme.colors.line};
  margin-right: 5px;
  margin-top: 4px;
`;

const Bullet = styled.div`
  height: 4px;
  width: 4px;
  min-width: 4px;
  background-color: ${Theme.colors.black};
  border-radius: 100%;
  display: inline-block;
  margin-right: 11px;
  margin-top: 6px;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 10px;
  align-items: center;
`;
const Rule = styled.div`
  display: flex;
  margin-right: 10px;
  font-size: 12px;
`;

const RuleText = styled.span`
  &:first-letter {
    text-transform: uppercase;
  }
  color: ${(props) => (props.valid ? Theme.colors.line : Theme.colors.black)};
`;

const PasswordValidator = ({ password, passwordRules }) => {
  return (
    <Container>
      {passwordRules.map((rule) => {
        const valid =
          typeof rule.valid !== 'undefined'
            ? rule.valid
            : rule.regex.test(password);
        return (
          <Rule key={rule.key}>
            {valid ? <CheckmarkIcon /> : <Bullet />}
            <RuleText valid={valid}>{t(rule.rule)}</RuleText>
          </Rule>
        );
      })}
    </Container>
  );
};

PasswordValidator.defaultProps = {
  password: '',
  passwordRules: [],
};

PasswordValidator.propTypes = {
  password: PropTypes.string.isRequired,
  passwordRules: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      rule: PropTypes.string.isRequired,
      regex: PropTypes.object,
      valid: PropTypes.bool,
    })
  ),
};

export default PasswordValidator;
